import { Box } from "@mui/material";
import { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/common/layout/Header";
import Footer from "../components/common/layout/Footer";
import { WithChildren, GlobalBackdrop } from "@duosoftbg/nacid-components";
import { AppModulesPageBlockerDialog } from "@duosoftbg/nacid-frontoffice-components";

type PortalLayoutProps = WithChildren<{
  hideSubHeader?: boolean;
}>;

const PortalLayout = (props: PortalLayoutProps) => {
  const { children, hideSubHeader = false } = props;
  return (
    <Fragment>
      <Header hideSubHeader={hideSubHeader} />
      <Box>
        {children}
        <Outlet />
      </Box>
      <Footer />
      <GlobalBackdrop />
      <AppModulesPageBlockerDialog />
    </Fragment>
  );
};

export default PortalLayout;
